import baseFetch from '../baseFetch';

export const fetchTides = async (lat, lon, userDetails = {}) =>
  baseFetch(`api/forecast/tides?lat=${lat}&lon=${lon}`, userDetails);

export const fetchNewTides = async (lat, lon, userDetails = {}) =>
  baseFetch(`tides?lat=${lat}&lon=${lon}`, userDetails);



// WEBPACK FOOTER //
// ./src/common/api/tides.js